import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';
import './App.css';
import FAQList from './FAQList';
import InventoryList from './InventoryList';
import CustomSignIn from './CustomSignIn';
import FAQData from './FAQData';
import SearchBar from './SearchBar';

const App = () => {
  const [authState, setAuthState] = useState('loading');
  const [searchQuery, setSearchQuery] = useState(''); 

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        await getCurrentUser();
        setAuthState('authenticated');
      } catch (error) {
        setAuthState('unauthenticated');
      }
    };

    checkAuthStatus();

  }, []);

  const filteredFAQs = FAQData.filter(faq =>
    faq.question.toLowerCase().includes(searchQuery.toLowerCase())
  );


  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={
            <>
          <CustomSignIn onAuthenticated={() => setAuthState('authenticated')} />
          <h4 style={{ textAlign: 'center' }}><a href='https://airbnb.com/h/huntington-metro' target='_location'>airbnb.com/huntington-metro</a></h4>
          </>
        } 
        />
        <Route
          path="/user"
          element={
            authState === 'loading' ? null : authState === 'authenticated' ? (
              <>
               <h2 style={{ textAlign: 'center' }}>5950 Grand Pavilion Way, Apt. 308, Alexandria, VA 22303</h2>
               <h3 style={{ textAlign: 'center' }}><a href='https://airbnb.com/h/huntington-metro' target='_location'>airbnb.com/huntington-metro</a></h3>
               <h1>House Guide and FAQ</h1>  
                <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
                <FAQList data={filteredFAQs} onSignOut={() => setAuthState('unauthenticated')} />
              </>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route 
          path="/admin" 
          element={
            authState === 'loading' ? null : authState === 'authenticated' ? 
            <InventoryList onSignOut={() => setAuthState('unauthenticated')} /> 
            : 
            <Navigate to="/" />
          } 
        />
      </Routes>
    </Router>
  );
};

export default App;